import { Hyperlink } from '@strata/react-hyperlink';

interface VideoGuideProps {
    thumbnailURL: string;
    title: string;
    navUrl: string;
    id: string;
}

export const VideoGuide = ({ thumbnailURL, title, navUrl, id }: VideoGuideProps) => (
    <div className="sds_knowledge-center__video-guide__item">
        <img src={thumbnailURL} alt={`${title} thumbnail`} width="300" height="155" />
        <div className="padding__around--medium">
            <Hyperlink navUrl={navUrl} linkText="Watch Video" id={id} openInNewTab />
        </div>
    </div>
);
